import * as actions from 'redux/actions/domainsData.actions'
import * as competitorsActions from 'redux/actions/competitors.actions'
import * as keywordPagesActions from 'redux/actions/keywordPages.actions'
import * as keywordGrossingActions from 'redux/actions/keywordGrossing.actions'
import * as keywordDiscoveryActions from 'redux/actions/keywordDiscovery.actions'
import * as keywordSavingsOverviewActions from 'redux/actions/keywordSavingsOverview.actions'
import * as userActions from 'redux/actions/user.actions'
import * as accountActions from 'redux/actions/account.actions'

import updateDomain from './domainsDataHelpers/updateDomain'

const defaultFilter = { device: '' }

const initialState = {
  currentFilters: defaultFilter,
  domains: {}
}

let defaultValue = {}

const domainsReducer = (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case actions.loadDomainExtended.type:
    case actions.loadDomainWithCompetitor.type:
    case actions.loadKeywords.type:
      return {
        ...state,
        currentFilters: payload.filters
      }

    case actions.loadDomainSuccess.type:
    case actions.loadCompetitorsSuccess.type:
    case actions.loadDomainTagsSuccess.type:
    case actions.loadKeywordsSuccess.type:
    case actions.loadKeywordsResultsSuccess.type:
    case actions.loadKeywordsChangesSuccess.type:
    case actions.loadKeywordsCompetitorsResultsSuccess.type:
    case actions.loadKeywordsCompetitorsChangesSuccess.type:
    case keywordPagesActions.getPagesSuccess.type:
    case keywordGrossingActions.getDomainKeywordGrossingSuccess.type:
    case keywordDiscoveryActions.getDomainKeywordDiscoverySuccess.type:
    case keywordSavingsOverviewActions.getDomainKeywordSavingsOverviewSuccess.type: {
      const domains = {
        ...state.domains,
        [payload.id]: updateDomain(state.domains[payload.id] || {}, { type, payload })
      }
      defaultValue = JSON.parse(JSON.stringify(state))
      return {
        ...state,
        domains: domains
      }
    }
    case competitorsActions.sortCompetitors.type: {
      const direction = payload.direction
      const value = payload.value
      return {
        ...state,
        [state.domains[payload.domainId]?.competitors?.attributes?.overview]:
          direction === 'default'
            ? state.domains[payload.domainId]?.competitors?.attributes?.overview.sort((a, b) =>
                a[value] > b[value] ? 1 : -1
              )
            : direction === 'ascending'
            ? state.domains[payload.domainId]?.competitors?.attributes?.overview.sort((a, b) =>
                a[value] < b[value] ? 1 : -1
              )
            : (state.domains[payload.domainId].competitors.attributes.overview = JSON.parse(
                JSON.stringify(
                  defaultValue?.domains[payload.domainId]?.competitors?.attributes?.overview
                )
              ))
      }
    }
    case actions.getShareLinkSuccess.type:
      return {
        ...state,
        shareLink: payload.shareLink
      }
    case accountActions.getAccountDataFailure.type:
    case userActions.logout.type:
    case actions.getShareLinkFailure.type:
      return initialState
    default:
      return state
  }
}

export default domainsReducer
